import { TENANT_ID } from "./api-factory"

const POST_HEADER = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
}

const GET_HEADER = {
    
}
const TenantHeader = {
    headers: {
        'X-Tenant-ID': TENANT_ID
    }
}

const TENANT_POST_HEADER = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Tenant-ID': TENANT_ID
}


export {
    POST_HEADER,
    GET_HEADER,
    TenantHeader,
    TENANT_POST_HEADER

}